module.exports = __webpack_public_path__ + "img/ico-ext.751de856.svg";